import React, { useEffect } from "react";
import {
  Container,
  Box,
  Grid,
  IconButton,
  Link,
  Hidden,
  Button,
  Typography,
  Paper,
  FormControl,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
// import useStyles from "./styles";
import { useFormContext } from "react-hook-form";

import { CardElement } from "@stripe/react-stripe-js";
import { useSharedBookReducer } from "../state";

const SurfLargeGroupCount = (props) => {
  const [bookState, dispatch] = useSharedBookReducer();
  const { register, setValue } = useFormContext();

  const count = bookState.m.biggrouppeople;

  const handleChangeBigGroupPeopleCount = (e) => {
    setValue("biggrouppeople", e.target.value);
    setValue("people", e.target.value);
    dispatch({
      type: "MERGE",
      payload: {
        m: { people: e.target.value, biggrouppeople: e.target.value },
      },
    });
  };

  useEffect(() => {
    if (count < 5) {
      handleChangeBigGroupPeopleCount({ target: { value: 5 } });
    }
    setValue("people", count);
  }, [count]);

  return (
    <div>
      <input
        {...register("biggrouppeople", { shouldUnregister: true })}
        type="hidden"
        defaultValue={bookState.m.biggrouppeople}
      />
      <input
        {...register("people", { shouldUnregister: true })}
        type="hidden"
        defaultValue={bookState.m.biggrouppeople}
      />
      {/* 

								<h3 class="title is-5">
									How many in your group?
								</h3>

								<div class="field is-horizontal">
									<div class="field-body">
										<div class="field is-expanded">
											<div class="control has-icons-left">

												<input class="input" type="number" placeholder="Number of People?" name="people"
													v-model="m.biggrouppeople" v-validate="'min_value:5'" v-validate="'required'"
													data-vv-validate-on="change">
												<span class="icon is-small is-left">
													<i class="fas fa-hashtag"></i>
												</span>
												<p class="help is-danger" v-if="errors.first('people')">
													\{{ errors.first('people') }}
												</p>
											</div>
										</div>
									</div>
								</div>
       */}
      <Typography variant="h5">How many in your group?</Typography>

      <TextField
        placeholder="Number of People"
        type="number"
        value={count}
        onChange={handleChangeBigGroupPeopleCount}
      />
    </div>
  );
};

export default SurfLargeGroupCount;
